import {connect} from 'react-redux';

import {mapClicked} from '../../actionCreators';

const Map = ({url, onClick}) => <img className="map" src={url} onClick={onClick} />;

const mapStateToProps = ({MapURL}) => ({url: MapURL});

const mapDispatchToProps = (dispatch, {isAnonymous}) => ({
    onClick: isAnonymous ? null : ({target, clientX, clientY}) => {
        const {width, height} = target;
        const {pageXOffset, pageYOffset} = window;
        const {top, left} = target.getBoundingClientRect();
        const {clientTop, clientLeft} = document.documentElement;

        /* Brackets are not optional because the values could
           be negative making them in fact not commutative. */
        const x = clientX - (left + pageXOffset - clientLeft) + pageXOffset;
        const y = clientY - (top + pageYOffset - clientTop) + pageYOffset;

        return dispatch(mapClicked(x, y, width, height));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Map);
